import { render, staticRenderFns } from "./prt.vue?vue&type=template&id=47f35ca6&"
import script from "./prt.vue?vue&type=script&lang=js&"
export * from "./prt.vue?vue&type=script&lang=js&"
import style0 from "./prt.vue?vue&type=style&index=0&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports